import { copyToClipboard } from '../utils';

/**
 * Handles the interactions for the "Copy to Clipboard" buttons
 */
export default class CopyButton {
    /**
     * Initializes the Copy button functionality
     * @param {Element} el   The element on which to initialize the button
     *                       functionality
     * @param {String}  text The text to copy when the button is clicked
     * @return {void}
     */
    constructor(el, text = '') {
        this.el = el;
        this.text = text;

        this.label = el.querySelector('span');
        this._labelText = this.label.innerText;

        this.el.addEventListener('click', e => {
            e.preventDefault();
            this._onClick();
        });
    }

    /**
     * Updates the text to copy when the button is clicked
     * @param  {String} text The new text to copy
     * @return {void}
     */
    setText(text = '') {
        this.text = text;
    }

    /**
     * Handle the click event actions
     * @return {void}
     */
    _onClick() {
        copyToClipboard(this.text);
        this._updateLabel('Copied!');
    }

    /**
     * Temporarily updates the label text before restoring the original content
     * @param  {String} text The new label text
     * @return {void}
     */
    _updateLabel(text) {
        this.label.innerText = text;
        setTimeout(() => {
            this.label.innerText = this._labelText;
        }, 3000);
    }
}
